export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref11927.cc194e37.jpg";